

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ChartConfiguration, Chart, registerables,ChartOptions } from 'chart.js';
import { BaseChartDirective,  } from 'ng2-charts';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

import { MatTableDataSource } from '@angular/material/table';
import { AnalyticsService } from '../../services/analytics.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { BillingData, Conversation } from '../../services/conversation';
import { AuthService } from '../../services/auth';
import { PermissionDeniedDialogComponent } from '../permission-denied-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CategoryDistributionComponent } from '../business-intelligence/category-distribution/category-distribution.component';
import { OutcomeDistributionComponent } from '../business-intelligence/outcome-distribution/outcome-distribution.component';
import { OutcomeRateComponent } from '../business-intelligence/outcome-rate/outcome-rate.component';
import { EngagementFrequencyComponent } from '../business-intelligence/engagement-frequency/engagement-frequency.component';
import { CrossTabComponent } from '../business-intelligence/cross-tab/cross-tab.component';
import { ConversationExplorerComponent } from '../business-intelligence/conversation-explorer/conversation-explorer.component';
import { ConversationDetailsComponent } from '../business-intelligence/conversation-details/conversation-details.component';
import { environment } from '../../../environments/environment';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    BaseChartDirective,
    MatProgressSpinnerModule,
    MatCard,
    MatCardHeader,MatCardTitle,MatCardContent,
    MatTab,
    MatTabGroup,
    CategoryDistributionComponent,
    OutcomeDistributionComponent,
    OutcomeRateComponent,
    EngagementFrequencyComponent,
    CrossTabComponent,
    ConversationExplorerComponent,
    ConversationDetailsComponent
    
  ],
  templateUrl: './dashboard.html',
  styleUrls: ['./dashboard.scss']
})
export class Dashboard implements OnInit {
  startDate = new Date('2025-09-20');
  endDate = new Date('2025-10-06');
  
  conversationId = '';
  selectedDay = '';
  loading = false;

  dailyStats: any[] = [];
  conversationActivity: any[] = [];
  conversations: any[] = [];
  conversationsDataSource = new MatTableDataSource<any>();
  displayedColumns = ['conversation_id', 'total_message_count', 'actions'];

  lineChartData: ChartConfiguration<'line'>['data'] = { labels: [], datasets: [] };
  // lineChartOptions: ChartConfiguration['options'] = {
  //   responsive: true,
  //   maintainAspectRatio: false
  // };

  barChartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };


    // Line chart options
  lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          font: { size: 12 },
          color: '#2c3e50'
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#2c3e50',
        titleColor: '#fff',
        bodyColor: '#fff'
      }
    },
    elements: {
      line: {
        borderWidth: 3,
        tension: 0.3 // makes the line smoother
      },
      point: {
        radius: 4,
        hoverRadius: 6,
        backgroundColor: '#3498db'
      }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#333' }
      },
      y: {
        grid: { color: '#eee' },
        ticks: { color: '#333' }
      }
    }
  };

  // Bar chart options
  barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#2c3e50',
        titleColor: '#fff',
        bodyColor: '#fff',
        callbacks: {
          label: (ctx) => ` ${ctx.dataset.label || ''}: ${ctx.formattedValue}`
        }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#333' }
      },
      y: {
        grid: { color: '#f0f0f0' },
        ticks: { color: '#333' }
      }
    },
    elements: {
      bar: {
        borderRadius: 6, // ✅ rounded bars
        borderSkipped: false
      }
    }
  };

  billingData?: BillingData;

  user;

  activeTab: 'stats' | 'activity' = 'stats';
  uniqueNumbers = 0



  constructor(private authService: AuthService,private analytics: AnalyticsService, 
    private router: Router,    private conversationService: Conversation,private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.endDate = new Date(); // today
    const start = new Date();
    start.setDate(start.getDate() - 7); // 7 days ago
    this.startDate = start;
      this.loadDailyStats();
      this.loadBilling();
      this.getVariables();

      this.authService.user$.subscribe(user=>{
      if(user){
        this.user = user;
      }
    })

    this.conversationService.getTotalDocs(environment.collections.CONVERSATIONS).then(res=>{
      // console.log('CONVERSATIONS:',res)
      this.uniqueNumbers = res
    })
  }

  // formatDate(date: Date): string {
  //   return date.toISOString().split('T')[0];
  // }

  formatDate(date: Date | string | null | undefined): string {
  if (!date) {
    return '';
  }

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) {
    console.warn('Invalid date passed to formatDate:', date);
    return '';
  }

  return parsedDate.toISOString().split('T')[0];
}


  // Load daily stats for line chart
  loadDailyStats(): void {
    this.loading = true;
    const start = this.formatDate(this.startDate);
    const end = this.formatDate(this.endDate);

    this.analytics.getDailyStats(start, end).subscribe({
      next: (data) => {
        // console.log(data)
        this.dailyStats = data;
        this.loadConversationsByDay(data[0]?.day)
        this.lineChartData = {
          labels: data.map(d => d.day),
          datasets: [
            {
              data: data.map(d => d.unique_conversations),
              label: 'Unique Conversations per Day',
              borderColor: 'var(--brand-primary)',
              backgroundColor: 'rgba(10, 38, 71, 0.15)',
              fill: true,
              tension: 0.3
            }
          ]
        };
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  // Load conversation activity bar chart
  loadConversationActivity(): void {
    if (!this.conversationId) return;
    this.loading = true;
    const start = this.formatDate(this.startDate);
    const end = this.formatDate(this.endDate);

    this.analytics.getConversationActivity(this.conversationId, start, end).subscribe({
      next: (data) => {
        // console.log(data)
        this.conversationActivity = data;
        this.barChartData = {
          labels: data.map(d => d.day),
          datasets: [
            {
              data: data.map(d => d.total_message_count),
              label: `Messages for ${this.conversationId}`,
              backgroundColor: '#d4a017'
            }
          ]
        };
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  // Click on line chart to load conversations for a day
  onChartClick(event: any): void {
    if (event?.active?.length > 0) {
      const clickedIndex = event.active[0].index;
      const clickedDay = this.lineChartData.labels?.[clickedIndex] as string;
      if (clickedDay) {
        this.selectedDay = clickedDay;
        this.loadConversationsByDay(clickedDay);
      }
    }
  }

  onBarChartClick(event: any): void{
    
    this.goToConversation(this.conversationId)

  }

  loadConversationsByDay(day: string): void {
    // console.log(day)
    this.loading = true;
    this.analytics.getConversationsByDay(day).subscribe({
      next: (data) => {
        this.conversations = data;
        this.conversationsDataSource.data = data;
        this.conversationId = this.conversations[0].conversation_id;
        this.loadConversationActivity()
        // console.log(this.conversations[0].conversation_id)
        this.loading = false;
        this.selectedDay = day;
      },
      error: () => (this.loading = false)
    });
  }

  async goToConversation(conversationId: string) {
   
    const tokenResult = await this.user.getIdTokenResult();
    const allowView = tokenResult.claims.view_convos === true||tokenResult.claims.admin === true;
    // console.log(tokenResult.claims)
     if (!allowView) {
        // Show modal
        const dialogRef = this.dialog.open(PermissionDeniedDialogComponent, {
          width: '400px',
          disableClose: true, // Prevent escape/click-out
          autoFocus: true
        });

        // Wait for user to click OK
        await dialogRef.afterClosed().toPromise();

      } else {
         this.router.navigate(['/conversation', conversationId]);
      }

   
  }

  loadBilling() {
  this.conversationService.getBillingByToken().subscribe({
    next: (data) => {
      this.billingData = data;
      // console.log('Billing snapshot:', data);
    },
    error: (err) => console.error('Error loading billing:', err)
  });
}

getVariables(){
  this.conversationService.getVariables().subscribe({
    next: (data) => {
      
      
      this.conversationService._templates.next(data['templates'])
      // console.log('Templates:', data['templates']);
    },
    error: (err) => console.error('Error loading billing:', err)
  });
}

onTabChange(event: any) {
  this.activeTab = event.index === 0 ? 'stats' : 'activity';

  // Optional cleanup
  if (this.activeTab === 'stats') {
    this.conversationId = '';
    this.barChartData = { labels: [], datasets: [] };
  }
}


}

